import { Input, Select } from 'antd';
import { MoreVerticalIcon } from '../../../utils/icons';

export const columns = [
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    width: '250px',
    render: (data: any) => {
      return <Input defaultValue={data} />;
    },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: '150px',
    render: (data: any) => {
      return <Input defaultValue={data} />;
    },
  },
  {
    title: 'Cost/Unit',
    dataIndex: 'cost_unit',
    key: 'cost_unit',
    render: (data: any) => {
      return <Input style={{ width: 120 }} defaultValue={data} />;
    },
  },
  {
    title: 'Action',
    key: 'action',

    width: '80px',
    render: (data: any) => {
      return <MoreVerticalIcon />;
    },
  },
];
